import { action, thunk } from 'easy-peasy';
import { PricingDataStoreModel } from './types';
import { getPricingDataList } from '../../api/pricing/pricing';
import handleError from '../../api/apiErrorHandle';
import createLatestRequestSignal from '../../services/latestRequestSignalService';

const nextPricingDataListSignal = createLatestRequestSignal();

const pricingDataStore: PricingDataStoreModel = {
  loading: false,
  pricingData: [],
  total: 0,
  maxPricingRequestId: undefined,
  currentFilter: {
    page: 1,
    orderBy: 'id',
    orderDirection: 'desc',
    filter: {
      marketplaceCodes: [],
    },
  },
  fetchPricingData: thunk(async (actions, payload, { fail }) => {
    const signal = nextPricingDataListSignal();

    actions.setLoading(true);
    try {
      const { data } = await getPricingDataList(payload.request, signal);
      actions.setPricingData({
        total: data.page.total,
        pricingData: data.page.data,
        maxPricingRequestId: data.maxPricingRequestId,
      });
    } catch (error) {
      if (!signal.aborted) {
        handleError(error);
        fail(error);
      }
    } finally {
      if (!signal.aborted) {
        actions.setLoading(false);
      }
    }
  }),
  setPricingData: action((state, payload) => {
    state.total = payload.total;
    state.pricingData = payload.pricingData;
    state.maxPricingRequestId = payload.maxPricingRequestId;
  }),
  setLoading: action((state, payload) => {
    state.loading = payload;
  }),
  setFilter: action((state, payload) => {
    state.currentFilter = payload;
  }),
  setMarketplaceCodes: action((state, payload) => {
    state.currentFilter.filter.marketplaceCodes = payload;
  }),
};

export default pricingDataStore;
